var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardpar30Days(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8085 28.5121H19.2921V34.8483H21.8085V28.5121Z",
    fill: "#26D9DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4283 33.59H13.6722V36.1063H27.4283V33.59Z",
    fill: "#0CA7A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1005 0H0V31.0285H41.1005V0Z",
    fill: "#FEDFB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5503 0H0V31.0285H20.5503V0Z",
    fill: "#FFF1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1005 0H0V4.65191H41.1005V0Z",
    fill: "#0CA7A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5503 0H0V4.65191H20.5503V0Z",
    fill: "#26D9DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7064 15.9544V8.78735H29.5394V11.3037H32.4108L24.1019 19.6125L16.9987 12.5093L6.91053 22.5975V8.78735H4.39417V26.8932H36.7064V24.3768H8.68981L16.9987 16.0679L24.1019 23.1711L34.19 13.0831V15.9544H36.7064Z",
    fill: "#E21B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardpar30Days);
export default __webpack_public_path__ + "static/media/dashboardpar30days.e18417bd5e11575d7f13d8a3e8a910c5.svg";
export { ForwardRef as ReactComponent };